/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, RoleListEntryFromJSON, RoleListEntryToJSON, } from './';
export function PagedResponseOfRoleListEntryFromJSON(json) {
    return PagedResponseOfRoleListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfRoleListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(RoleListEntryFromJSON)),
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'size': !exists(json, 'size') ? undefined : json['size']
    };
}
export function PagedResponseOfRoleListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'totalElements': value.totalElements,
        'hasNext': value.hasNext,
        'page': value.page,
        'hasPrevious': value.hasPrevious,
        'numberOfElements': value.numberOfElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(RoleListEntryToJSON)),
        'nextPage': PageRequestToJSON(value.nextPage),
        'metaData': MetaDataToJSON(value.metaData),
        'previousPage': PageRequestToJSON(value.previousPage),
        'size': value.size
    };
}
